import React from 'react';
import logo from '../../../imgs/logo.png';
import Url from './url';
import { doAction } from '../../utils';
import './index.scss';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  logout = async () => {
    await doAction(Url.logout, {}, null);
    // const { hash } = window.location;
    // const arr = hash.split('/');
    const tenantUid = 1;
    window.location.hash = `#/candidate/${tenantUid}/login`;
  };

  render() {
    return (
      <div className="header">
        <div className="header__logo">
          <img src={logo} alt="header__logo" />
        </div>
        <span className="header__logout" onClick={this.logout}>
          退出
        </span>
      </div>
    );
  }
}

export default Header;
